import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDataAccessSearchHistorySlice } from './get';

export const coreDataSecurityDataAccessSearchHistoryReducers = combineReducers({
	get: getCoreDataSecurityDataAccessSearchHistorySlice.asyncReducers
});

export const coreDataSecurityDataAccessSearchHistoryWatchers = combineAllWatchers([
	getCoreDataSecurityDataAccessSearchHistorySlice.asyncWatchers
]);
